// order used for search filter in demandes apprenants
export var BourseVirtualStatus;
(function (BourseVirtualStatus) {
    BourseVirtualStatus["UNVERIFIED"] = "UNVERIFIED";
    BourseVirtualStatus["VERIFIED"] = "VERIFIED";
    BourseVirtualStatus["ENTERED_FORMATION"] = "ENTERED_FORMATION";
    BourseVirtualStatus["NOT_ENTERED_FORMATION"] = "NOT_ENTERED_FORMATION";
})(BourseVirtualStatus || (BourseVirtualStatus = {}));
//# sourceMappingURL=bourse.js.map